import { act } from 'react';
import { call, put } from 'redux-saga/effects';

import {
  applyCouponLoading,
  errorNotificationPreferences,
  isLoadingGetDisabledlQuestions,
  isLoadingResetAllQuestions,
  isLoadingResetIndividualQuestion,
  loadingCustomer,
  loadingGetFavoriteQuestions,
  loadingNotificationPreferences,
  loadingRemoveQuestions,
  removeQuestionFromList,
  resetDisabledQuestionObject,
  resetFavoriteQuestionObject,
  setAllFavoriteQuestions,
  setAllRates,
  setApplyCouponMessage,
  setAvailableQualForDailyQuiz,
  setCustomerMessage,
  setCustomerSiteMockUp,
  setCustomSync,
  setCustomSyncMessage,
  setDisabledQuestions,
  setDisabledQuestionsCount,
  setEditPaymentDetailsMessage,
  setEditPaymentDetailsSuccess,
  setEditPaymentDetailsWaiting,
  setFavoriteQuestions,
  setFavoriteQuestionsCount,
  setFlashcardOnlyAction,
  setFlashcardOnlyMessage,
  setFlashcardOnlyWaiting,
  setIsLoadingCustomSync,
  setIsLoadingCustomSyncData,
  setIsLoadingStudySpeedSettings,
  setLastCouponUser,
  setLoadingSubmittedQuestions,
  setLoadingSubscription,
  setNotificationPreferences,
  setPossibleCyclesForUpdateExam,
  setPossibleCyclesForUser,
  setRemoveFavoriteQuestions,
  setSpecificNotificationPreference,
  setStudySpeedSettingsMessage,
  setSubmittedQuestions,
  setSwitchPfeSktMessage,
  setSwitchPfeSktValue,
  setSwitchPfeSktWaiting,
  setUpdateCycleWaiting,
  setUpdateEmailMessage,
  setUpdateEmailWaiting,
  setUpdatePasswordMessage,
  setUpdatePasswordWaiting,
  setUpdatePersonalDataMessage,
  setUpdateProfilePrivacyMessage,
  setUpdateProfilePrivacyWaiting,
  setUpdateRatingExamMessage,
  setUpdateRatingExamSuccess,
  setUpdateRatingExamWaiting,
  setUpdateTimezoneMessage,
  setUpdateTimezoneWaiting,
  setUpdateUsernameMessage,
  setUpdateUsernameWaiting,
  setUploadImageMessage,
  setUploadImageSuccess,
  setUploadingImageWaiting,
  setUserSubscription,
  successGetDisabledlQuestions,
  successNotificationPreferences,
  successResetAllQuestions,
  successResetIndividualQuestion,
} from '../actions/accountSettingsAction';
import { setCounterSubmitted } from '../actions/studyMainActions';
import { setChangeStudySpeedSettings } from '../actions/userActions';
import Services from '../services/index';

export function* updateUsernameSaga(action) {
  try {
    yield put(setUpdateUsernameWaiting(true));
    yield call(
      Services.AccountSettingsService.updateUsernameService,
      action.username,
    );
    yield call(Services.UserService.getLoggedStudent);
    yield put(setUpdateUsernameWaiting(false));
    yield put(
      setUpdateUsernameMessage({
        type: 'success',
        text: 'Username updated successfully!',
      }),
    );
  } catch (error) {
    yield put(
      setUpdateUsernameMessage({ type: 'error', text: error.response.data }),
    );
    yield put(setUpdateUsernameWaiting(false));
  }
}

export function* updatePersonalDataSagas(action) {
  try {
    yield call(
      Services.AccountSettingsService.updatePersonalData,
      action.personalData,
    );
    yield call(Services.UserService.getLoggedStudent);
    yield put(
      setUpdatePersonalDataMessage({
        type: 'success',
        text: 'Personal data updated successfully!',
      }),
    );
  } catch (error) {
    yield put(
      setUpdatePersonalDataMessage({
        type: 'error',
        text: error.response.data,
      }),
    );
  }
}

export function* getAllRatesSaga() {
  try {
    const response = yield call(
      Services.AccountSettingsService.getAllPublicRates,
    );
    yield put(setAllRates(response));
  } catch (err) {
    yield put(setAllRates([]));
  }
}

export function* updateProfilePrivacySaga(action) {
  try {
    yield put(setUpdateProfilePrivacyWaiting(true));
    yield call(
      Services.AccountSettingsService.updateProfilePrivacyService,
      action.privacy,
    );
    yield call(Services.UserService.getLoggedStudent);
    yield put(setUpdateProfilePrivacyWaiting(false));
    yield put(
      setUpdateProfilePrivacyMessage({
        type: 'success',
        text: 'Profile privacy updated successfully!',
      }),
    );
  } catch (error) {
    yield put(
      setUpdateProfilePrivacyMessage({
        type: 'error',
        text: error.response.data,
      }),
    );
    yield put(setUpdateProfilePrivacyWaiting(false));
  }
}

export function* updateSwitchPfeSktSaga(action) {
  try {
    yield put(setSwitchPfeSktWaiting(true));
    const response = yield call(
      Services.AccountSettingsService.updateSwitchPfeSktService,
      action.value,
    );
    yield put(setSwitchPfeSktWaiting(false));
    yield put(setSwitchPfeSktValue(response.currentRateId));
    yield put(
      setSwitchPfeSktMessage({
        type: 'success',
        text: 'switched pfe/skt successfully!',
      }),
    );
  } catch (error) {
    yield put(setSwitchPfeSktWaiting(false));
    yield put(
      setSwitchPfeSktMessage({
        type: 'error',
        text: error.response.data,
      }),
    );
  }
}

export function* updateFlashcardOnlySaga(action) {
  try {
    yield put(setFlashcardOnlyWaiting(true));
    const response = yield call(
      Services.AccountSettingsService.updateFlashcardOnlyService,
      action.payload,
    );
    yield put(setFlashcardOnlyWaiting(false));
    yield put(setFlashcardOnlyAction(response.flashcardOnly));
    yield put(
      setFlashcardOnlyMessage({
        type: 'success',
        text: 'Flashcard updated successfully!',
      }),
    );
  } catch (error) {
    yield put(
      setFlashcardOnlyMessage({
        type: 'error',
        text: error.response.data,
      }),
    );
  }
}

export function* updateTimezoneSaga(action) {
  try {
    yield put(setUpdateTimezoneWaiting(true));
    yield call(
      Services.AccountSettingsService.updateTimezoneService,
      action.timezone,
    );
    yield call(Services.UserService.getLoggedStudent);
    yield put(setUpdateTimezoneWaiting(false));
    yield put(
      setUpdateTimezoneMessage({
        type: 'success',
        text: 'Timezone updated successfully!',
      }),
    );
  } catch (error) {
    yield put(
      setUpdateTimezoneMessage({ type: 'error', text: error.response.data }),
    );
    yield put(setUpdateTimezoneWaiting(false));
  }
}

export function* updateEmailSaga(action) {
  try {
    yield put(setUpdateEmailWaiting(true));
    yield call(
      Services.AccountSettingsService.updateEmailService,
      action.email,
    );

    yield call(Services.UserService.getLoggedStudent);
    yield put(setUpdateEmailWaiting(false));
    yield put(
      setUpdateEmailMessage({
        type: 'success',
        text: 'Email updated successfully!',
      }),
    );
  } catch (error) {
    yield put(
      setUpdateEmailMessage({ type: 'error', text: error.response.data }),
    );
    yield put(setUpdateEmailWaiting(false));
  }
}

export function* updatePasswordSaga(action) {
  try {
    yield put(setUpdatePasswordWaiting(true));
    yield call(
      Services.AccountSettingsService.updatePasswordService,
      action.oldPassword,
      action.newPassword,
    );
    yield call(Services.UserService.getLoggedStudent);
    yield put(setUpdatePasswordWaiting(false));
    yield put(
      setUpdatePasswordMessage({
        type: 'success',
        text: 'Password updated successfully!',
      }),
    );
  } catch (error) {
    yield put(
      setUpdatePasswordMessage({ type: 'error', text: error.response.data }),
    );
    yield put(setUpdatePasswordWaiting(false));
  }
}

export function* uploadProfileImageSagas(action) {
  try {
    yield put(setUploadingImageWaiting(true));
    yield call(
      Services.AccountSettingsService.uploadProfileImage,
      action.imgFile,
    );
    yield call(Services.UserService.getLoggedStudent);
    yield put(setUploadingImageWaiting(false));
    yield put(setUploadImageSuccess(true));
    yield put(
      setUploadImageMessage({
        type: 'success',
        text: 'Avatar edited successfully!',
      }),
    );
  } catch (error) {
    yield put(setUploadingImageWaiting(false));
    yield put(setUploadImageSuccess(false));
    yield put(
      setUploadImageMessage({ type: 'error', text: error.response.data }),
    );
  }
}

export function* updateRatingExamSagas(action) {
  try {
    yield put(setUpdateRatingExamWaiting(true));
    yield call(Services.AccountSettingsService.updateRatingExam, {
      id: action.id,
      rate: action.rate.id,
      dutyState: action.dutyState,
      rank: action.rank,
      cycleSelected: action.cycleSelected,
    });

    yield call(Services.UserService.getLoggedStudent);

    yield put(setUpdateRatingExamSuccess(true));
    yield put(setUpdateRatingExamWaiting(false));
    yield put(
      setUpdateRatingExamMessage({
        type: 'success',
        text: 'Rating exam updated successfully!',
      }),
    );
  } catch (error) {
    yield put(
      setUpdateRatingExamMessage({ type: 'error', text: error.response.data }),
    );
    yield put(setUpdateRatingExamSuccess(false));
    yield put(setUpdateRatingExamWaiting(false));
  }
}

export function* loadPossibleCyclesForUserSagas(action) {
  try {
    yield put(setUpdateCycleWaiting(true));
    const response = yield call(
      Services.AccountSettingsService.loadPossibleCyclesForUser,
      action.user,
    );

    yield put(setPossibleCyclesForUser(response));
    yield put(setUpdateCycleWaiting(false));
  } catch (err) {
    yield put(setPossibleCyclesForUser([]));
    yield put(setUpdateCycleWaiting(false));
  }
}

export function* loadPossibleCyclesForUpdateExam(action) {
  try {
    const response = yield call(
      Services.AccountSettingsService.loadPossibleCyclesForUpdateExam,
      action.rate,
      action.rank,
      action.dutyState,
    );
    yield put(setPossibleCyclesForUpdateExam(response));
  } catch (err) {
    throw new Error(error);
  }
}

// MANAGE SUBSCRIPTION FUNCTION
export function* loadUserSubscriptionSagas(action) {
  try {
    yield put(setLoadingSubscription(true));
    const response = yield call(
      Services.AccountSettingsService.loadUserSubscription,
      false,
    );
    yield put(setUserSubscription(response));
    yield put(setLoadingSubscription(false));
  } catch (err) {
    yield put(setLoadingSubscription(false));
    yield put(setUserSubscription(null));
  }
}

export function* editPaymentDetailsSagas(action) {
  try {
    yield put(setEditPaymentDetailsWaiting(true));
    const response = yield call(
      Services.AccountSettingsService.editPaymentDetails,
      action.subscriptionId,
      action.details,
    );

    if (response === 'OK') {
      const userSubscription = yield call(
        Services.AccountSettingsService.loadUserSubscription,
        false,
      );
      yield put(setUserSubscription(userSubscription));
      yield put(setEditPaymentDetailsWaiting(false));
      yield put(
        setEditPaymentDetailsMessage({
          type: 'success',
          text: 'Payment details edited successfully!',
        }),
      );
      yield put(setEditPaymentDetailsSuccess(true));
    }
  } catch (error) {
    yield put(setEditPaymentDetailsWaiting(false));
    yield put(
      setEditPaymentDetailsMessage({
        type: 'error',
        text: error.response.data,
      }),
    );
  }
}

// DISABLED QUESTIONS FUNCTIONS
export function* resetAllDisabledQuestionsSagas(action) {
  try {
    yield put(isLoadingResetAllQuestions(true));

    const response = yield call(
      Services.AccountSettingsService.resetAllDisabledQuestions,
    );

    yield put(setDisabledQuestionsCount(response.count));
    yield put(resetDisabledQuestionObject());
    yield put(isLoadingResetAllQuestions(false));
    yield put(successResetAllQuestions(true));
  } catch (error) {
    yield put(isLoadingResetAllQuestions(false));
    yield put(successResetAllQuestions(false));
  }
}

export function* resetDisabledIndividualQuestionSagas(action) {
  try {
    yield put(isLoadingResetIndividualQuestion(true));
    const response = yield call(
      Services.AccountSettingsService.resetIndividualQuestionService,
      action.questionId,
    );

    yield put(removeQuestionFromList(action.questionId, response.count));
    yield put(isLoadingResetIndividualQuestion(false));
    yield put(successResetIndividualQuestion(true));
  } catch (error) {
    yield put(isLoadingResetIndividualQuestion(false));
    yield put(successResetIndividualQuestion(true));
  }
}

export function* getDisabledQuestionsSagas(action) {
  try {
    yield put(isLoadingGetDisabledlQuestions(true));

    const response = yield call(
      Services.AccountSettingsService.getDisabledQuestionsService,
      action.limit,
      action.skip,
    );

    yield put(setDisabledQuestions(response.questions));
    yield put(setDisabledQuestionsCount(response.count));
    yield put(isLoadingGetDisabledlQuestions(false));
    yield put(successGetDisabledlQuestions(true));
  } catch (error) {
    yield put(isLoadingGetDisabledlQuestions(false));
    yield put(successGetDisabledlQuestions(false));
  }
}

export function* getFavoriteQuestionsSaga(action) {
  try {
    yield put(loadingGetFavoriteQuestions(true));
    const response = yield call(
      Services.AccountSettingsService.getFavoriteQuestionsService,
      action.limit,
      action.skip,
    );
    yield put(setFavoriteQuestions(response.questionsFavorite));
    yield put(setFavoriteQuestionsCount(response.count));
    yield put(loadingGetFavoriteQuestions(false));
  } catch (error) {
    yield put(loadingGetFavoriteQuestions(false));
    yield put(errorNotificationPreferences(error));
  }
}

export function* getAllFavoriteQuestionsSaga() {
  try {
    yield put(loadingGetFavoriteQuestions(true));
    const response = yield call(
      Services.AccountSettingsService.getFavoriteQuestionsService,
    );
    yield put(setAllFavoriteQuestions(response.questionsFavorite));
    yield put(loadingGetFavoriteQuestions(false));
  } catch (error) {
    yield put(loadingGetFavoriteQuestions(false));
    yield put(errorNotificationPreferences(error));
  }
}

export function* getSubmittedQuestionsSaga() {
  try {
    yield put(setLoadingSubmittedQuestions(true));
    const response = yield call(
      Services.AccountSettingsService.getSubmittedQuestionsService,
    );
    yield put(setSubmittedQuestions(response.questions));
    if (response.counter) {
      yield put(setCounterSubmitted(response.counter));
    }
  } catch (error) {
  } finally {
    yield put(setLoadingSubmittedQuestions(false));
  }
}

export function* removeFavoriteQuestionsSaga(action) {
  try {
    yield put(loadingRemoveQuestions(true));
    yield call(
      Services.AccountSettingsService.removeFavoriteQuestionsService,
      action.userId,
      action.questionsId,
    );
    yield put(setRemoveFavoriteQuestions(action.questionsId));
    yield put(loadingRemoveQuestions(false));
  } catch (error) {
    yield put(loadingRemoveQuestions(false));
    yield put(errorNotificationPreferences(error));
  }
}

export function* removeAllFavoriteQuestionsSaga(action) {
  try {
    yield put(isLoadingResetAllQuestions(true));

    const response = yield call(
      Services.AccountSettingsService.removeAllFavoriteQuestionsService,
    );

    yield put(setFavoriteQuestionsCount(response.count));
    yield put(resetFavoriteQuestionObject());
    yield put(isLoadingResetAllQuestions(false));
    yield put(successResetAllQuestions(true));
  } catch (error) {
    yield put(isLoadingResetAllQuestions(false));
    yield put(successResetAllQuestions(false));
  }
}

// NOTIFICATION PREFERENCES

export function* getNotificationPreferencesSagas(action) {
  try {
    yield put(loadingNotificationPreferences(true)); // Here we update the reducer state. (We must do this after the API call)

    const response = yield call(
      Services.AccountSettingsService.getNotificationPreferencesService,
    );

    yield put(setNotificationPreferences(response));
    yield put(loadingNotificationPreferences(false));
    yield put(successNotificationPreferences(true));
  } catch (exception) {
    yield put(errorNotificationPreferences(exception));
  }
}

export function* sendNotificationPreferencesSagas(action) {
  try {
    yield put(loadingNotificationPreferences(true)); // Here we update the reducer state. (We must do this after the API call)

    const parameter = action.parameter;
    const value = action.value; // We need certain data to use the endpoint

    const response = yield call(
      Services.AccountSettingsService.sendNotificationPreferencesService,
      parameter,
      value,
    );

    yield put(setSpecificNotificationPreference(response));
    yield put(loadingNotificationPreferences(false));
    yield put(successNotificationPreferences(true));
  } catch (exception) {
    alert(exception);
    yield put(errorNotificationPreferences(exception));
  }
}

// ACTIVATE RECEIVE QUESTIONS NOTIFICATIONS FROM COMPLETE FLASH CARD
export function* activateReceiveQuestionsNotificationSagas(action) {
  try {
    const active = action.active;
    const description = action.description;
    yield call(
      Services.AccountSettingsService.activateQuestionsNotificationService,
      active,
      description,
    );
  } catch (exeption) {}
}

// CUSTOMER SITE MOCK-UP
export function* customerSiteMockUp(action) {
  try {
    yield put(loadingCustomer(true));
    const response = yield call(
      Services.AccountSettingsService.customerMockUpService,
      action.customer,
    );
    yield put(
      setCustomerMessage({
        type: 'success',
        text: 'Registration has been successfully created!',
      }),
    );
    yield put(setCustomerSiteMockUp(response));
    yield put(loadingCustomer(false));
  } catch (err) {
    setCustomerMessage({
      type: 'error',
      text: err.response.data,
    });
  }
}

export function* getCustomerSiteMockUpSaga(action) {
  try {
    yield put(loadingCustomer(true));
    const response = yield call(
      Services.AccountSettingsService.getCustomerMockUp,
      action.userId,
    );
    yield put(setCustomerSiteMockUp(response));
    yield put(loadingCustomer(false));
  } catch (err) {}
}

// APPLY COUPON WEB

export function* applyCouponUserSaga(action) {
  try {
    yield put(applyCouponLoading(true));
    const response = yield call(
      Services.AccountSettingsService.applyCouponUser,
      action.coupon,
    );

    if (response && response.message && !response.status) {
      yield put(
        setApplyCouponMessage({
          type: 'error',
          text: response.message,
        }),
      );
    } else {
      yield put(setLastCouponUser(response));
      yield put(
        setApplyCouponMessage({
          type: 'success',
          text: 'Coupon successfully applied!',
        }),
      );
    }
    yield put(applyCouponLoading(false));
  } catch (err) {
    yield put(
      setApplyCouponMessage({
        type: 'error',
        text: 'Invalid coupon!',
      }),
    );
  }
}

export function* getLastCouponUserSaga() {
  try {
    const response = yield call(
      Services.AccountSettingsService.getLastCouponUser,
    );

    yield put(setLastCouponUser(response));
  } catch (err) {}
}

export function* setStudySpeedSettingsSaga(action) {
  try {
    yield put(setIsLoadingStudySpeedSettings(true));
    const response = yield call(
      Services.AccountSettingsService.setStudySpeedSettings,
      action.option,
    );

    if (response.studySpeed) {
      yield put(setChangeStudySpeedSettings(response.studySpeed));
    }

    yield put(
      setStudySpeedSettingsMessage({
        type: 'success',
        message: 'Study speed updated successfully!',
      }),
    );
  } catch (error) {
    yield put(
      setStudySpeedSettingsMessage({
        type: 'error',
        message: error.response.data,
      }),
    );
  } finally {
    yield put(setIsLoadingStudySpeedSettings(false));
  }
}

// Qual for daily quiz
export function* getAvailableQualForDailyQuizSaga() {
  try {
    const response = yield call(
      Services.AccountSettingsService.getQualsAvailableForDailyQuiz,
    );
    yield put(setAvailableQualForDailyQuiz(response));
  } catch (err) {
    yield put(setAvailableQualForDailyQuiz({}));
  }
}

// Custom Sync
export function* getCustomSyncSaga() {
  try {
    yield put(setIsLoadingCustomSyncData(true));
    const response = yield call(
      Services.AccountSettingsService.getCustomSyncService,
    );
    yield put(setCustomSync(response));
  } catch (err) {
    yield put(setCustomSync(null));
  } finally {
    yield put(setIsLoadingCustomSyncData(false));
  }
}

export function* updateCustomSyncSaga(action) {
  try {
    yield put(setIsLoadingCustomSync(true));
    const response = yield call(
      Services.AccountSettingsService.updateCustomSyncService,
      action.customSync,
    );
    yield put(setCustomSync(response.customSync || response));
    yield put(
      setCustomSyncMessage({
        type: 'success',
        message: 'Mobile sync settings updated successfully!',
      }),
    );
  } catch (error) {
    const responseData = error.response && error.response.data;
    const message =
      (typeof responseData === 'string' && responseData) ||
      (responseData && responseData.message) ||
      error.message ||
      'Unable to update mobile sync settings.';
    yield put(
      setCustomSyncMessage({
        type: 'error',
        message,
      }),
    );
  } finally {
    yield put(setIsLoadingCustomSync(false));
  }
}
